import { NavLink, Outlet } from "react-router-dom";
import { useIntl } from "react-intl";
import ApplicationLayoutBodyNavigation from "@rio-cloud/rio-uikit/ApplicationLayoutBodyNavigation";
import SubNavigation from "@rio-cloud/rio-uikit/SubNavigation";
import BackofficeLayout from "../BackofficeLayout";

const SupportBackofficePage = () => {
  const intl = useIntl();
  const submenu = (
    <ApplicationLayoutBodyNavigation>
      <SubNavigation
        navItems={[
          {
            key: "groups",
            route: (
              <NavLink to="/backoffice/support/groups">
                {intl.formatMessage({ id: "intl-msg:backoffice.support.groups" })}
              </NavLink>
            ),
          },
        ]}
      />
    </ApplicationLayoutBodyNavigation>
  );

  return (
    <BackofficeLayout submenu={submenu}>
      <Outlet />
    </BackofficeLayout>
  );
};

export default SupportBackofficePage;
